import type { CSSProperties } from "react"
import { Wrench } from "lucide-react"
import { useI18n } from "@/lib/i18n"

export function ClientsStrip() {
  const { t } = useI18n()

  // Duplicate the list so the marquee loops seamlessly.
  const loop = [...t.clients.items, ...t.clients.items]

  return (
    <section
      aria-label={t.clients.title}
      className="relative border-t border-border py-20 md:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-14 xl:px-20">
        {/* Header */}
        <header className="flex items-start gap-5">
          <span
            aria-hidden
            className="inline-flex size-9 shrink-0 items-center justify-center border border-border text-primary"
          >
            <Wrench className="size-4" strokeWidth={1.6} />
          </span>
          <div className="flex-1">
            <h2 className="text-[clamp(1.5rem,2.8vw,2.2rem)] leading-[1.1] font-extrabold tracking-[-0.025em] text-foreground">
              {t.clients.title}
            </h2>
            <p className="mt-3 max-w-2xl text-[14.5px] leading-[1.65] text-foreground/65">
              {t.clients.lead}
            </p>
          </div>
        </header>
      </div>

      {/* Full-bleed marquee — single endless row */}
      <div
        className="marquee mt-10"
        style={
          {
            "--marquee-gap": "3rem",
            "--marquee-duration": "40s",
          } as CSSProperties
        }
      >
        <div className="marquee-track items-center">
          {loop.map((name, i) => (
            <span
              key={`${name}-${i}`}
              className="inline-flex shrink-0 items-center gap-12 text-[18px] font-semibold tracking-[-0.02em] text-foreground/75 md:text-[20px]"
              aria-hidden={i >= t.clients.items.length}
            >
              {name}
              <span
                aria-hidden
                className="inline-block size-1.5 rounded-full bg-primary/60"
              />
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
